import React from 'react';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { styled } from '@mui/material/styles';
import { paramsQuerryChekerUrlSelect,paramsQuerryChekerUrl } from '../../../DisplayComponent';


const SelectMy = styled(Select)(({ theme }) => ({

  ' .MuiSelect-select': {
    padding: "7.5px 16px"
  }

}));

function getUrlFiltrSort (checked) {
  let filter = "";
  for (var key in checked) {
    checked[key].map(u => {
              filter += `filter[${key}][]=${u}&`;
    })
  }

  return filter;
}

function SelectSort(props) {

  const [valueSort, setSorts] = React.useState(paramsQuerryChekerUrlSelect(props));

  const handleChange = (event) => {
    let getUrlFiltr;
    props.getFiltrSelectedAC(event.target.value);

    setSorts(event.target.value);
    if (props.getUrlFiltr == "" && props.valueSelectedUrl != "") { getUrlFiltr = ""; } else { getUrlFiltr = "&" + props.getUrlFiltr; }
    props.params.navigate(`/${props.catalogUrl}/?${getUrlFiltrSort(props.checked)}${event.target.value}&countItems=${props.pageSize}&page=${props.currentPage}`)
    props.getCatalogItems(props.pageSize, props.currentPage, `&${getUrlFiltrSort(props.checked)}${event.target.value}`);
  };

  if (paramsQuerryChekerUrlSelect(props) !== props.valueSelected) { props.getFiltrSelectedAC(paramsQuerryChekerUrlSelect(props)); }
  return (
    <Box sx={{ minWidth: 120 }}>
      <FormControl fullWidth>
        <SelectMy
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={valueSort}
          onChange={handleChange}
        >
          {
            props.filterSort
              .map((u, k) => {
                return (
                  <MenuItem sx={{ display: "grid" }} key={k} value={u.value}>{u.label}</MenuItem>
                )
              })
          }
        </SelectMy>
      </FormControl>
    </Box>
  );
}

export default SelectSort;